<style>
#addNewField .v--modal-box.v--modal {
  min-height: 200px !important;
  min-width: 300px !important;
}
#addNewField * {
  font-size: 12px;
}
</style>

<template>
  <Modal
    modalName="addNewField"
    title="Dodawanie nowego pola"
    @saved="saveField"
    :buttons="['save']"
  >
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 id="modalSelect__fieldTypes">
          <v-text-field height="16" label="Nazwa kolumny" v-model="fieldName"></v-text-field>
        </v-flex>
        <v-flex xs12 id="modalSelect__fieldTypes">
          <v-select
            height="16"
            :items="columnTypes"
            attach="#modalSelect__fieldTypes .v-input__slot"
            label="Typ kolumny"
            :return-object="true"
            item-text="name"
            v-model="fieldType"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    columnTypes: [
      {
        name: "Tekst",
        key: "text"
      },
      {
        name: "Liczba całkowita",
        key: "integer"
      },
      {
        name: "Liczba rzeczywista",
        key: "float"
      }
    ],
    fieldName: undefined,
    fieldType: undefined,
    editing: false,
    isImported: false
  }),
  methods: {
    saveField() {
      if (this.isImported) {
        this.$root.$emit("fieldSavedDataImportModal", [
          this.fieldName,
          this.fieldType,
          this.editing
        ]);
      } else {
        this.$root.$emit("fieldSaved", [
          this.fieldName,
          this.fieldType,
          this.editing
        ]);
      }
      this.closed();
    },
    editField(data) {
      this.editing = true;
      for (let el of this.columnTypes) {
        if (el.name == data[1]) {
          this.fieldType = el;
          break;
        }
      }
      this.fieldName = data[0];
    },
    closed() {
      this.$modal.hide("addNewField");
      this.fieldName = undefined;
      this.fieldType = undefined;
      this.editing = false;
      this.isImported = false;
    },
    dataImportModal() {
      this.isImported = true;
    }
  },
  mounted() {
    this.$root.$on("editField", this.editField);
    this.$root.$on("dataImportModal", this.dataImportModal);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/modals/AddNewField.vue